import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { ref: "fileForm" };
const _hoisted_2 = ["accept", "id", "multiple"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("input", {
            class: "hide",
            ref: "uploadFileRef",
            type: "file",
            accept: _ctx.accept,
            id: _ctx.id,
            multiple: _ctx.multiple,
            onChange: _cache[0] || (_cache[0] = ($event) => (_ctx.inputUpdate()))
        }, null, 40, _hoisted_2)
    ], 512));
}
